import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = localStorage.getItem("geni_token");
    if (!t) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        // Cache stored timezone so todayIso() can honour it globally.
        if (r.data?.timezone) localStorage.setItem("geni_timezone", r.data.timezone);
        else localStorage.removeItem("geni_timezone");
      })
      .catch(() => localStorage.removeItem("geni_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (token) => {
    localStorage.setItem("geni_token", token);
    const r = await api.get("/auth/me");
    setUser(r.data);
    if (r.data?.timezone) localStorage.setItem("geni_timezone", r.data.timezone);
  };

  const logout = () => {
    localStorage.removeItem("geni_token");
    localStorage.removeItem("geni_timezone");
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
